<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Disponibilidade de Produção
    </div>

    <div>
      <BasePrint
        printableElementId="availableProductionReportTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Disponibilidade de Produção"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        v-if="availableProduction"
        class="mt-3 mb-3"
      />
    </div>

    <div id="availableProductionReportTable">
      
      <v-row>
        <v-col cols="12" v-if="availableProduction">
          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="availableProduction.varieties"
            :indexNested="true"
            :disablePagination="true"
            :containTopToolbar="false"
            :maskFields="maskFields"
            :hasTableTitle="false"
            :itemClass="itemClasses"
            :hasDefaultPageTitle="false"
          />
        </v-col>
      </v-row>
    </div>
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      availableProduction: null,
      pageLoading: false,
      loading: false,
      showEmptyItems: false,
      stockListLoading: false,
      stockList: [],
      stockIds: [],
      tableHeaders: [
        { text: "Variedade", align: "left", sortable: false, value: "variety" },
        { text: "Qtd. em Depósito", align: "left", sortable: false, value: "storageQuantity" },
        { text: "Qtd. a ser colhida", align: "left", sortable: false, value: "toBeCropedQuantity" },
        { text: "Qtd. perdida", align: "left", sortable: false, value: "lossQuantity" },
        { text: "Qtd. em pedido de venda", align: "left", sortable: false, value: "saleOrderQuantity" },
        { text: "Resultado", align: "left", sortable: false, value: "result" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'storageQuantity', mask: 'number' },
        { field: 'toBeCropedQuantity', mask: 'number' },
        { field: 'lossQuantity', mask: 'number' },
        { field: 'saleOrderQuantity', mask: 'number' },
        { field: 'result', mask: 'number' },
      ]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    // this.loadAllStocks();
    this.loadAvailableProductionReport();
  },
  mounted() { 
  },
  computed: {
    // tableHeaders: function () { }
  },
  methods: {
    loadAvailableProductionReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_AVAILABLE_PRODUCTION_REPORT,
          // variables: {
          //   harvestId: this.harvestId, 
          //   cultureId: this.cultureId, 
          //   stockIds: this.stockIds,
          //   showEmptyItems: this.showEmptyItems
          // },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.availableProduction = response.data.accountContext.availableProductionReport;
          console.log("availableProduction", this.availableProduction);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    itemClasses: function(item) {
      // if (item.status == "pending_payment") {
        if (item.result < 0) {
          return "negative_result";
        } else {
          return "positive_result";
        }
      // }
    },
    // loadAllStocks: function() {
    //   this.stockListLoading = true;
    //   this.$apollo
    //     .query({
    //       query: LOAD_ALL_STOCKS_QUERY,
    //       // variables: {
    //       //   harvestId: this.harvestId,
    //       //   cultureId: this.cultureId
    //       // },
    //       fetchPolicy: "no-cache"
    //     })
    //     .then(response => {
    //       this.stockList = response.data.accountContext.allStocks;
    //       this.stockIds = [];
    //     })
    //     .catch(response => console.log(response))
    //     .finally(() => (this.stockListLoading = false));
    // },
    // getCostByPeriodId: function(periodsList, periodId) {
    //   let period = periodsList.find(period => period.periodId == periodId);
    //   if (period) {
    //     return period.cost;
    //   } 
    //   return 0;
    // },
    // getCostHaByPeriodId: function(periodsList, periodId) {
    //   let period = periodsList.find(period => period.periodId == periodId);
    //   if (period) {
    //     return period.costHa;
    //   } 
    //   return 0;
    // },
    // loadAllStocks: function() {
    //     this.stockListLoading = true;
    //     this.$apollo
    //       .query({
    //         query: LOAD_ALL_HARVEST_QUERY,
    //         fetchPolicy: "no-cache"
    //       })
    //       .then(response => {
    //         this.harvestList = response.data.accountContext.allHarvests;
    //       })
    //       .catch(response => console.log(response))
    //       .finally(() => (this.harvestListLoading = false));
    // },
    // loadCulturesFromHarvest: function() {
    //   if (this.harvestId){
    //     this.cultureListLoading = true;
    //     this.$apollo
    //       .query({
    //         query: CULTURES_FROM_HARVEST_QUERY,
    //         variables: {
    //           harvestId: this.harvestId
    //         },
    //         fetchPolicy: "no-cache"
    //       })
    //       .then(response => {
    //         this.cultureList = response.data.accountContext.allCulturesFromHarvest;
    //         this.cultureId = null;
    //         this.periodIds = [];
    //       })
    //       .catch(response => console.log(response))
    //       .finally(() => (this.cultureListLoading = false));
        
    //     this.loadPeriodsFromHarvestAndCulture();
    //   }
    // },
  }
};



const LOAD_AVAILABLE_PRODUCTION_REPORT = gql `
{
  accountContext {
    availableProductionReport
  }
}
`;

// const LOAD_ALL_HARVEST_QUERY = gql `
//   {
//     accountContext {
//       allHarvests {
//         id
//         name
//       }
//     }
//   }
// `;

// const CULTURES_FROM_HARVEST_QUERY = gql `
//   query ($harvestId: ID!) {
//     accountContext {
//       allCulturesFromHarvest(harvestId: $harvestId){
//         id
//         name
//       }
//     }
//   }
// `;

// const LOAD_ALL_STOCKS_QUERY = gql `
//   {
//     accountContext {
//       allStocks{
//         id
//         name
//       }
//     }
//   }
// `;

</script>

<style scoped>
  ::v-deep .positive_result {
    color: blue;
  }
  ::v-deep .negative_result {
    color: red;
  }
</style>
